module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiM4OTg5OWI7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMCwwSDIwVjIwSDBaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0xMC4zMzMsMmE4LjMzMyw4LjMzMywwLDEsMCw4LjMzMyw4LjMzM0E4LjMzNiw4LjMzNiwwLDAsMCwxMC4zMzMsMlpNMTQuNSwxMS4xNjdIMTEuMTY3VjE0LjVIOS41VjExLjE2N0g2LjE2N1Y5LjVIOS41VjYuMTY3aDEuNjY3VjkuNUgxNC41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMzMzIC0wLjMzMykiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_circle.svg
// module id = 6PCB
// module chunks = 3